(() => {
  const root = document.querySelector('[data-adawat-collection]');
  if (!root) return;

  const sortSelect = root.querySelector('[data-adawat-sort]');
  const grid = root.querySelector('[data-collection-grid]');
  const infiniteEl = root.querySelector('[data-collection-infinite]');
  const infiniteStatus = root.querySelector('[data-collection-infinite-status]');
  const infiniteLive = root.querySelector('[data-collection-infinite-live]');
  const countEl = root.querySelector('.adawat-collection__count');
  const mainEl = root.querySelector('.adawat-collection__main');
  const currentHandle = root.dataset.collectionHandle || '';
  const sellingFastHandle = (root.dataset.sellingFastHandle || '').trim();
  const sellingFastHandles = (root.dataset.sellingFastHandles || '')
    .split(',')
    .map((handle) => handle.trim())
    .filter(Boolean);
  const sellingFastUseHandles = root.dataset.sellingFastUseHandles === 'true';
  const sellingFastLabel = root.dataset.sellingFastLabel || 'Selling Fast';

  const initialCountHTML = countEl ? countEl.innerHTML : '';
  const initialNextUrl = infiniteEl?.dataset.nextUrl || '';
  let initialGridHTML = grid ? grid.innerHTML : '';
  let categoryTimer = null;
  let loadToken = 0;
  let infiniteLoading = false;
  let infiniteObserver = null;
  let infiniteEnabled = Boolean(initialNextUrl);
  let pauseObserve = false;
  const offersFirstCount = 20;

  function collectionsBase() {
    return `${window.Shopify?.routes?.root || '/'}collections/`.replace(/\/{2,}/g, '/');
  }

  function productUrl(handle) {
    return `${window.Shopify?.routes?.root || '/'}products/${handle}`.replace(/\/{2,}/g, '/');
  }

  function escapeHtml(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function normalizeSwatchKey(name) {
    return String(name || '')
      .toLowerCase()
      .replace(/[_/-]+/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
  }

  const adminSwatchMap = Object.create(null);

  function rememberAdminSwatch(name, color) {
    const key = normalizeSwatchKey(name);
    const chip = String(color || '').trim();
    if (key && chip) adminSwatchMap[key] = chip;
  }

  function loadAdminSwatchMap() {
    const node = root.querySelector('[data-adawat-admin-swatches]');
    if (!node) return;
    try {
      const parsed = JSON.parse(node.textContent || '{}');
      Object.entries(parsed || {}).forEach(([name, color]) => rememberAdminSwatch(name, color));
    } catch (_error) {
      /* ignore malformed theme JSON */
    }
  }

  function harvestAdminSwatches(scope = root) {
    scope.querySelectorAll('.adawat-product-card__swatch').forEach((btn) => {
      const name = btn.getAttribute('aria-label') || btn.getAttribute('title');
      const color = (btn.style.getPropertyValue('--swatch-bg') || '').trim();
      const image = (btn.style.getPropertyValue('--swatch-image') || '').trim();
      rememberAdminSwatch(name, image || color);
    });
  }

  function swatchStyleVars(color) {
    const chip = String(color || '').trim();
    if (chip.startsWith('url(')) return `--swatch-image: ${chip}`;
    return `--swatch-bg: ${chip}`;
  }

  function resolveSwatchColor(name) {
    const key = normalizeSwatchKey(name);
    if (adminSwatchMap[key]) return adminSwatchMap[key];
    const map = {
      black: '#111111',
      noir: '#111111',
      'jet black': '#111111',
      'matte black': '#111111',
      white: '#f5f5f5',
      blanc: '#f5f5f5',
      'bright white': '#f5f5f5',
      'off white': '#f7f1e3',
      offwhite: '#f7f1e3',
      ivory: '#f7f1e3',
      eggshell: '#f7f1e3',
      cream: '#faf3e8',
      creamy: '#faf3e8',
      beige: '#e8d9c4',
      'light beige': '#e8d9c4',
      sand: '#e8d9c4',
      nude: '#e8d9c4',
      natural: '#e8d9c4',
      'dark beige': '#c4b5a0',
      taupe: '#c4b5a0',
      greige: '#c4b5a0',
      tan: '#c4a574',
      camel: '#c4a574',
      khaki: '#c4a574',
      sandstone: '#c4a574',
      brown: '#8b5a2b',
      'dark brown': '#5c3310',
      chocolate: '#5c3310',
      coffee: '#5c3310',
      espresso: '#5c3310',
      walnut: '#5c3310',
      mahogany: '#5c3310',
      wood: '#b08968',
      oak: '#b08968',
      teak: '#b08968',
      bamboo: '#b08968',
      'light grey': '#d1d5db',
      'light gray': '#d1d5db',
      grey: '#9ca3af',
      gray: '#9ca3af',
      'dark grey': '#4b5563',
      'dark gray': '#4b5563',
      charcoal: '#4b5563',
      graphite: '#4b5563',
      anthracite: '#4b5563',
      smoke: '#4b5563',
      slate: '#4b5563',
      silver: '#c0c0c0',
      chrome: '#c0c0c0',
      nickel: '#c0c0c0',
      stainless: '#c0c0c0',
      'stainless steel': '#c0c0c0',
      steel: '#c0c0c0',
      navy: '#1e3a5f',
      'navy blue': '#1a237e',
      blue: '#2563eb',
      'royal blue': '#2563eb',
      'light blue': '#38bdf8',
      sky: '#38bdf8',
      'sky blue': '#38bdf8',
      'baby blue': '#38bdf8',
      teal: '#0d9488',
      cyan: '#06b6d4',
      aqua: '#06b6d4',
      turquoise: '#14b8a6',
      red: '#dc2626',
      rouge: '#dc2626',
      crimson: '#dc2626',
      burgundy: '#7f1d1d',
      maroon: '#7f1d1d',
      wine: '#7f1d1d',
      orange: '#f97316',
      rust: '#f97316',
      coral: '#fb923c',
      peach: '#fb923c',
      apricot: '#fb923c',
      yellow: '#eab308',
      lemon: '#eab308',
      yello: '#eab308',
      gold: '#d4a017',
      mustard: '#d4a017',
      champagne: '#d4a017',
      'light green': '#86efac',
      mint: '#86efac',
      lime: '#86efac',
      green: '#16a34a',
      sage: '#9caf88',
      olive: '#6b8e23',
      'olive green': '#6b6b32',
      emerald: '#059669',
      'dark green': '#166534',
      forest: '#166534',
      army: '#166534',
      'army green': '#166534',
      pink: '#ec4899',
      'hot pink': '#ec4899',
      magenta: '#ec4899',
      fuchsia: '#ec4899',
      'nude pink': '#e89ad4',
      'dusty rose': '#c4a99a',
      rose: '#f43f5e',
      blush: '#f43f5e',
      purple: '#7c3aed',
      violet: '#7c3aed',
      lavender: '#c4b5fd',
      lilac: '#c4b5fd',
      plum: '#6b21a8',
      copper: '#b45309',
      bronze: '#b45309',
      clear: '#e5e7eb',
      transparent: '#e5e7eb',
      glass: '#e5e7eb',
    };
    if (map[key]) return map[key];
    const rules = [
      ['beige', '#e8d9c4'],
      ['sand', '#e8d9c4'],
      ['nude', '#e8d9c4'],
      ['cream', '#faf3e8'],
      ['ivory', '#faf3e8'],
      ['khaki', '#c4a574'],
      ['camel', '#c4a574'],
      ['tan', '#c4a574'],
      ['taupe', '#c4a574'],
      ['chocolate', '#5c3310'],
      ['coffee', '#5c3310'],
      ['walnut', '#5c3310'],
      ['wood', '#b08968'],
      ['brown', '#8b5a2b'],
      ['black', '#111111'],
      ['off white', '#f7f1e3'],
      ['white', '#f5f5f5'],
      ['light grey', '#d1d5db'],
      ['light gray', '#d1d5db'],
      ['dark grey', '#4b5563'],
      ['dark gray', '#4b5563'],
      ['charcoal', '#4b5563'],
      ['grey', '#9ca3af'],
      ['gray', '#9ca3af'],
      ['silver', '#c0c0c0'],
      ['navy', '#1e3a5f'],
      ['sky', '#38bdf8'],
      ['light blue', '#38bdf8'],
      ['teal', '#0d9488'],
      ['turquoise', '#14b8a6'],
      ['cyan', '#06b6d4'],
      ['blue', '#2563eb'],
      ['burgundy', '#7f1d1d'],
      ['maroon', '#7f1d1d'],
      ['red', '#dc2626'],
      ['coral', '#fb923c'],
      ['peach', '#fb923c'],
      ['orange', '#f97316'],
      ['gold', '#d4a017'],
      ['mustard', '#d4a017'],
      ['yellow', '#eab308'],
      ['sage', '#9caf88'],
      ['olive', '#6b8e23'],
      ['mint', '#86efac'],
      ['lime', '#86efac'],
      ['light green', '#86efac'],
      ['emerald', '#059669'],
      ['forest', '#166534'],
      ['army', '#166534'],
      ['dark green', '#166534'],
      ['green', '#16a34a'],
      ['pink', '#ec4899'],
      ['rose', '#f43f5e'],
      ['lavender', '#c4b5fd'],
      ['lilac', '#c4b5fd'],
      ['plum', '#6b21a8'],
      ['purple', '#7c3aed'],
      ['violet', '#7c3aed'],
      ['copper', '#b45309'],
      ['bronze', '#b45309'],
    ];
    for (const [needle, hex] of rules) {
      if (key.includes(needle)) return hex;
    }
    return '#d1d5db';
  }

  function imageForColor(product, colorValue, colorIndex) {
    const wanted = String(colorValue || '').toLowerCase().trim();
    if (!wanted) return '';
    const variants = product.variants || [];
    const match = variants.find((variant) => {
      const optionVal = variant.options?.[colorIndex] || variant[`option${colorIndex + 1}`];
      return String(optionVal || '').toLowerCase().trim() === wanted;
    });
    const featured = match?.featured_image;
    if (featured?.src) return featured.src;
    if (typeof featured === 'string' && featured) return featured;
    const images = product.images || [];
    const byAlt = images.find((img) => String(img.alt || '').toLowerCase().includes(wanted));
    return byAlt?.src || '';
  }

  function renderCardSwatches(product) {
    const options = product.options || [];
    const colorIndex = options.findIndex((opt) => {
      const name = String(opt.name || '').toLowerCase();
      return (
        name === 'color' ||
        name === 'colour' ||
        name === 'لون' ||
        name.includes('color') ||
        name.includes('colour')
      );
    });
    if (colorIndex < 0) return '';
    const colorOpt = options[colorIndex];
    const values = Array.isArray(colorOpt.values) ? colorOpt.values : [];
    if (!values.length) return '';
    const shown = values.slice(0, 8);
    const extra = values.length - shown.length;
    const swatches = shown
      .map((value, index) => {
        const label = escapeHtml(value);
        const color = resolveSwatchColor(value);
        const image = imageForColor(product, value, colorIndex);
        const imageAttr = image ? ` data-image-src="${escapeHtml(image)}"` : '';
        const selected = index === 0 ? ' is-selected' : '';
        const pressed = index === 0 ? 'true' : 'false';
        return `<button type="button" class="adawat-product-card__swatch${selected}" title="${label}" aria-label="${label}" aria-pressed="${pressed}" style="${swatchStyleVars(color)};"${imageAttr}></button>`;
      })
      .join('');
    const more = extra > 0 ? `<span class="adawat-product-card__swatch-more" aria-hidden="true">+${extra}</span>` : '';
    return `<div class="adawat-product-card__swatches" role="group" aria-label="${escapeHtml(colorOpt.name)}">${swatches}${more}</div>`;
  }

  /** products.json prices are dollars ("2.00"), not cents. */
  function priceToDollars(value) {
    const n = Number(value);
    if (!Number.isFinite(n) || n <= 0) return 0;
    return n;
  }

  function priceToCents(value) {
    return Math.round(priceToDollars(value) * 100);
  }

  function formatMoney(amount) {
    const dollars = priceToDollars(amount);
    if (!dollars) return '$0.00';
    const cents = priceToCents(amount);
    if (typeof window.adawatFormatMoney === 'function') return window.adawatFormatMoney(cents);
    return `$${dollars.toFixed(2)}`;
  }

  function priceAsDollars(value) {
    return priceToDollars(value);
  }

  function isTenPicksOk(product) {
    const variants = product.variants || [];
    const prices = [product.price_max, product.price_min, product.price, ...variants.map((v) => v.price)]
      .map(priceAsDollars)
      .filter((n) => n > 0);
    if (!prices.length) return true;
    return Math.max(...prices) <= 10.0001;
  }

  function cardPriceDollars(item) {
    const direct = Number(item.querySelector('[data-price-dollars]')?.getAttribute('data-price-dollars') || '');
    if (Number.isFinite(direct) && direct > 0) return direct;
    const raw = item.querySelector('[data-product-price]')?.getAttribute('data-product-price') || '';
    const n = Number(String(raw).replace(/[^0-9.]/g, ''));
    return Number.isFinite(n) ? n : 0;
  }

  function stripOverTenPicks(scope = grid) {
    if (currentHandle !== '10-picks' || !scope) return;
    scope.querySelectorAll('.adawat-collection__grid-item').forEach((item) => {
      if (cardPriceDollars(item) > 10.0001) item.remove();
    });
  }

  function sitewidePercent() {
    const raw = Math.round(Number(document.body?.dataset?.sitewidePercent || 0));
    if (raw < 1 || raw > 95) return 0;
    return raw;
  }

  function saleFromProduct(product, collectionHandles) {
    const variants = product.variants || [];
    const variantId = variants[0]?.id;
    const minPrice = Number(product.price_min ?? product.price ?? variants[0]?.price ?? 0);
    const handles = collectionHandles || [];
    const cfg = window.__ADAWAT_SITEWIDE_SALE__ || {};
    const allItems = cfg.all_items === true || cfg.allItems === true;
    const sitewideHandles = [
      String(cfg.collection_handle || '').toLowerCase().trim(),
      ...((cfg.collection_handles || []).map((handle) => String(handle || '').toLowerCase().trim())),
    ].filter(Boolean);
    const sitewide =
      allItems || (sitewideHandles.length && handles.some((handle) => sitewideHandles.includes(handle)))
        ? sitewidePercent()
        : 0;
    const byVariant = window.__ADAWAT_SALE_BY_VARIANT__ || {};
    const specific = variantId ? Number(byVariant[String(variantId)] || 0) : 0;
    let fromRules = 0;
    const layers = window.__ADAWAT_SALE_RULES__;
    const discounts = Array.isArray(layers?.discounts) ? layers.discounts : layers?.percent ? [layers] : [];
    const tags = (product.tags || []).map((tag) => String(tag || '').toLowerCase().trim());
    const normHandles = handles.map((handle) => String(handle || '').toLowerCase().trim()).filter(Boolean);
    if (
      tags.includes('no-discount') ||
      tags.includes('no discount') ||
      normHandles.some((handle) => handle.includes('no-discount'))
    ) {
      return { onSale: false, price: minPrice, compare: 0, percent: 0, basis: '' };
    }
    const excludeSet = new Set(
      [
        'back-to-school',
        'no-discount',
        'no-discount-for-1-week-collection',
        ...(cfg.exclude_handles || []),
        ...(layers?.exclude_handles || []),
        ...String(document.body?.dataset?.saleExclude || '').split(','),
      ]
        .map((handle) => String(handle || '').toLowerCase().trim())
        .filter(Boolean)
    );
    const softExcluded = normHandles.some(
      (handle) => excludeSet.has(handle) && !sitewideHandles.includes(handle)
    );
    discounts.forEach((layer) => {
      const pct = Number(layer?.percent) || 0;
      if (pct <= 0) return;
      const ids = (layer.product_ids || []).map(String);
      const layerHandles = (layer.collection_handles || [])
        .map((handle) => String(handle || '').toLowerCase().trim())
        .filter(Boolean);
      if (ids.includes(String(product.id))) fromRules = Math.max(fromRules, pct);
      if (layerHandles.some((handle) => normHandles.includes(handle))) {
        fromRules = Math.max(fromRules, pct);
      }
    });
    const clamp = (n) => {
      const v = Math.round(Number(n) || 0);
      return v >= 1 && v <= 95 ? v : 0;
    };
    const extra = Math.max(clamp(specific), clamp(fromRules));
    const percent = extra > 0 ? extra : softExcluded ? 0 : sitewide;
    const first = variants[0] || {};
    const compareAt = Number(first.compare_at_price || product.compare_at_price_min || 0);
    // Automatic % remultiplies catalog price (matches cart). Compare-at alone = strikethrough, no invented badge %.
    if (percent > 0) {
      const price = Math.round(minPrice * (100 - percent)) / 100;
      return { onSale: true, price, compare: minPrice, percent, basis: 'auto' };
    }
    if (compareAt > minPrice && minPrice > 0) {
      return {
        onSale: true,
        price: minPrice,
        compare: compareAt,
        percent: 0,
        basis: 'compare',
      };
    }

    return { onSale: false, price: minPrice, compare: 0, percent: 0, basis: '' };
  }

  function getDrawer() {
    return document.querySelector('[data-collection-drawer]');
  }

  function getDrawerBody() {
    return document.querySelector('[data-collection-drawer-body]');
  }

  function getSidebar() {
    return document.querySelector('[data-collection-sidebar]');
  }

  function bindDrawerChrome(panel) {
    if (!panel || panel.dataset.chromeBound === '1') return;
    panel.dataset.chromeBound = '1';
    panel.addEventListener('cancel', () => {
      panel.classList.remove('is-open');
      document.documentElement.classList.remove('adawat-collection-filters-open');
    });
    panel.addEventListener('click', (event) => {
      if (event.target === panel) closeDrawer();
    });
  }

  function fillDrawer() {
    const bodyEl = getDrawerBody();
    const side = getSidebar();
    if (!bodyEl || !side) return bodyEl;
    if (!bodyEl.dataset.cloned) {
      bodyEl.innerHTML = side.innerHTML;
      bodyEl.dataset.cloned = '1';
      delete bodyEl.dataset.facetsBound;
    }
    if (!bodyEl.dataset.facetsBound) {
      bodyEl.querySelectorAll('[data-bound]').forEach((el) => {
        delete el.dataset.bound;
      });
      bindFacets(bodyEl);
      bodyEl.dataset.facetsBound = '1';
    }
    syncCategoryCheckboxes(bodyEl);
    syncColorActiveState(selectedColors(root));
    return bodyEl;
  }

  function openDrawer() {
    const panel = getDrawer();
    if (!panel) return;

    if (panel.parentElement !== document.body) {
      document.body.appendChild(panel);
    }
    bindDrawerChrome(panel);
    fillDrawer();
    panel.classList.add('is-open');
    panel.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('adawat-collection-filters-open');
    if (typeof panel.showModal === 'function') {
      if (!panel.open) panel.showModal();
    }
  }

  function closeDrawer() {
    const panel = getDrawer();
    if (!panel) return;
    panel.classList.remove('is-open');
    panel.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('adawat-collection-filters-open');
    if (typeof panel.close === 'function' && panel.open) {
      panel.close();
    }
  }

  window.AdawatCollectionFilters = { open: openDrawer, close: closeDrawer };

  function updateSort(value) {
    const url = new URL(window.location.href);
    if (value) url.searchParams.set('sort_by', value);
    else url.searchParams.delete('sort_by');
    url.searchParams.delete('page');
    window.location.href = url.toString();
  }

  function toNumber(value, fallback = 0) {
    const n = Number(String(value || '').replace(/[^\d.]/g, ''));
    return Number.isFinite(n) ? n : fallback;
  }

  function bindPriceFilter(priceRoot) {
    if (!priceRoot || priceRoot.dataset.bound === '1') return;
    priceRoot.dataset.bound = '1';

    const slider = priceRoot.querySelector('[data-price-slider]');
    const minRange = priceRoot.querySelector('[data-price-min]');
    const maxRange = priceRoot.querySelector('[data-price-max]');
    const minInput = priceRoot.querySelector('[data-price-input-min]');
    const maxInput = priceRoot.querySelector('[data-price-input-max]');
    const labelMin = priceRoot.querySelector('[data-price-label-min]');
    const labelMid = priceRoot.querySelector('[data-price-label-mid]');
    const labelMax = priceRoot.querySelector('[data-price-label-max]');
    if (!slider || !minRange || !maxRange || !minInput || !maxInput) return;

    const rangeMax = Math.max(
      toNumber(priceRoot.dataset.priceCeiling, 0),
      toNumber(maxRange.max, 0),
      toNumber(maxInput.max, 0),
      1
    );

    if (labelMid) labelMid.textContent = String(Math.round(rangeMax / 2));

    const syncFill = () => {
      const min = toNumber(minRange.value, 0);
      const max = toNumber(maxRange.value, rangeMax);
      const left = Math.max(0, Math.min(100, (min / rangeMax) * 100));
      const right = Math.max(0, Math.min(100, 100 - (max / rangeMax) * 100));
      slider.style.setProperty('--price-fill-left', `${left}%`);
      slider.style.setProperty('--price-fill-right', `${right}%`);
      if (labelMin) labelMin.textContent = String(Math.round(min));
      if (labelMax) labelMax.textContent = String(Math.round(max));
    };

    const syncFromRanges = () => {
      let min = toNumber(minRange.value, 0);
      let max = toNumber(maxRange.value, rangeMax);
      if (min > max) {
        if (document.activeElement === minRange) max = min;
        else min = max;
      }
      minRange.value = String(min);
      maxRange.value = String(max);
      minInput.value = String(min);
      maxInput.value = String(max);
      syncFill();
    };

    const syncFromInputs = () => {
      let min = Math.min(Math.max(toNumber(minInput.value, 0), 0), rangeMax);
      let max = Math.min(Math.max(toNumber(maxInput.value, rangeMax), 0), rangeMax);
      if (min > max) max = min;
      minRange.value = String(min);
      maxRange.value = String(max);
      minInput.value = String(min);
      maxInput.value = String(max);
      syncFill();
    };

    minRange.addEventListener('input', () => {
      syncFromRanges();
      schedulePriceApply();
    });
    maxRange.addEventListener('input', () => {
      syncFromRanges();
      schedulePriceApply();
    });
    minInput.addEventListener('change', () => {
      syncFromInputs();
      applyFilters();
    });
    maxInput.addEventListener('change', () => {
      syncFromInputs();
      applyFilters();
    });
    syncFromRanges();
  }

  function schedulePriceApply() {
    clearTimeout(priceTimer);
    priceTimer = setTimeout(() => applyFilters(), 280);
  }

  function selectedCats(scope) {
    return [...scope.querySelectorAll('[data-cat-checkbox]:checked')]
      .map((el) => el.value)
      .filter(Boolean);
  }

  function syncCategoryCheckboxes(scope) {
    const url = new URL(window.location.href);
    const catsParam = url.searchParams.get('cats') || '';
    const selected = new Set(
      catsParam
        .split(',')
        .map((v) => v.trim())
        .filter(Boolean)
    );

    scope.querySelectorAll('[data-cat-checkbox]').forEach((input) => {
      if (selected.size) {
        input.checked = selected.has(input.value);
      } else if (!catsParam) {
        // URL has no cats → keep current collection checked only if it was the default all-box
      }
      input.closest('.adawat-collection__cat-check')?.classList.toggle('is-active', input.checked);
    });
  }

  function syncAllCategoryUIs() {
    [root, getDrawerBody()].forEach((scope) => {
      if (!scope) return;
      syncCategoryCheckboxes(scope);
    });
  }

  const productCache = new Map();
  let priceTimer = null;

  async function getProducts(handle) {
    if (productCache.has(handle)) return productCache.get(handle);
    const list = await fetchCollectionProducts(handle);
    productCache.set(handle, list);
    return list;
  }

  function selectedColors(scope) {
    const seen = new Set();
    const colors = [];
    (scope || root).querySelectorAll('[data-color-label].is-active').forEach((el) => {
      const label = el.getAttribute('data-color-label');
      if (!label || seen.has(label)) return;
      seen.add(label);
      colors.push(label);
    });
    return colors;
  }

  function parseColorParam(raw) {
    return String(raw || '')
      .split(',')
      .map((v) => v.trim())
      .filter(Boolean);
  }

  function syncColorActiveState(activeLabels) {
    const active = new Set(
      (activeLabels || []).map((label) => String(label || '').toLowerCase()).filter(Boolean)
    );
    document.querySelectorAll('[data-color-label]').forEach((el) => {
      const label = String(el.getAttribute('data-color-label') || '').toLowerCase();
      const on = active.has(label);
      el.classList.toggle('is-active', on);
      el.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
  }

  function currentFilterState() {
    const cats = selectedCats(root);
    const colors = selectedColors(root);
    const availIn = !!root.querySelector('[data-availability="in"].is-active');
    const availOut = !!root.querySelector('[data-availability="out"].is-active');
    let availability = '';
    if (availIn && !availOut) availability = 'in';
    if (availOut && !availIn) availability = 'out';
    const minInput = root.querySelector('[data-price-input-min]');
    const maxInput = root.querySelector('[data-price-input-max]');
    const ceiling = toNumber(root.querySelector('[data-price-filter]')?.dataset.priceCeiling, 0);
    const min = Math.round(toNumber(minInput?.value, 0));
    const max = Math.round(toNumber(maxInput?.value, ceiling || 0));
    const ceil = Math.round(ceiling || 0);
    const priceActive = min > 0 || (ceil > 0 && max > 0 && max < ceil);
    return { cats, colors, availability, min, max, ceiling: ceil, priceActive };
  }

  function syncFilterUrl(state) {
    const url = new URL(window.location.href);
    url.searchParams.delete('page');
    if (!state.cats.length) url.searchParams.delete('cats');
    else url.searchParams.set('cats', state.cats.join(','));
    if (state.colors?.length) url.searchParams.set('color', state.colors.join(','));
    else url.searchParams.delete('color');
    if (state.availability) url.searchParams.set('availability', state.availability);
    else url.searchParams.delete('availability');
    [...url.searchParams.keys()].forEach((key) => {
      if (key.includes('price') || (/colou?r/i.test(key) && key.startsWith('filter.'))) {
        url.searchParams.delete(key);
      }
    });
    window.history.replaceState({}, '', url.toString());
  }

  function productUnitPrice(product) {
    const variant = product.variants?.[0] || {};
    return toNumber(variant.price, 0);
  }

  function productIsInStock(product) {
    const variants = product?.variants || [];
    if (variants.length) return variants.some((variant) => variant.available !== false);
    return product?.available !== false;
  }

  function productMatchesFilters(product, state) {
    if (currentHandle === '10-picks' && !isTenPicksOk(product)) return false;
    if (state.colors?.length) {
      const productColors = extractProductColors(product);
      const hit = state.colors.some((color) => productColors.has(color));
      if (!hit) return false;
    }
    if (state.availability === 'in' && !productIsInStock(product)) return false;
    if (state.availability === 'out' && productIsInStock(product)) return false;
    const price = productUnitPrice(product);
    if (state.min > 0 && price < state.min) return false;
    if (state.ceiling > 0 && state.max > 0 && state.max < state.ceiling && price > state.max) return false;
    return true;
  }

  function cardMatchesFilters(item, state) {
    if (currentHandle === '10-picks' && cardPriceDollars(item) > 10.0001) return false;
    if (state.colors?.length) {
      const labels = new Set(
        [...item.querySelectorAll('.adawat-product-card__swatch')].map((el) =>
          canonicalColorName(el.getAttribute('aria-label') || el.getAttribute('title') || '').toLowerCase()
        )
      );
      const hit = state.colors.some((color) => labels.has(String(color || '').toLowerCase()));
      if (!hit) return false;
    }
    const price = cardPriceDollars(item);
    if (state.min > 0 && price < state.min) return false;
    if (state.ceiling > 0 && state.max > 0 && state.max < state.ceiling && price > state.max) return false;
    return true;
  }

  function filtersAreDefault(state) {
    const catsDefault = !state.cats.length || (state.cats.length === 1 && state.cats[0] === currentHandle);
    return catsDefault && !state.colors?.length && !state.availability && !state.priceActive;
  }

  function restoreOriginalGrid() {
    if (!grid) return;
    grid.innerHTML = initialGridHTML;
    grid.hidden = false;
    hideEmptyState();
    setInfiniteEnabled(Boolean(initialNextUrl), initialNextUrl);
    root.querySelectorAll('.adawat-collection__count').forEach((el) => {
      el.innerHTML = initialCountHTML;
    });
    window.adawatBindCardGalleries?.();
    window.AdawatWishlist?.sync?.();
    window.AdawatRefreshSale?.();
  }

  function setActiveGroup(selector, on) {
    root.querySelectorAll(selector).forEach((el) => el.classList.toggle('is-active', on));
  }

  function updateResultsCount(count) {
    if (!countEl) return;
    const label = count === 1 ? 'result' : 'results';
    countEl.textContent = `${count} ${label} found`;
  }

  function setInfiniteStatus(visible) {
    if (!infiniteStatus) return;
    infiniteStatus.hidden = !visible;
  }

  function setInfiniteEnabled(enabled, nextUrl) {
    infiniteEnabled = Boolean(enabled && (nextUrl || infiniteEl?.dataset.nextUrl));
    if (infiniteEl) {
      if (nextUrl != null) {
        if (nextUrl) infiniteEl.dataset.nextUrl = nextUrl;
        else delete infiniteEl.dataset.nextUrl;
      }
      infiniteEl.hidden = !infiniteEnabled;
    }
    if (infiniteEnabled) observeInfinite();
    else {
      infiniteObserver?.disconnect();
      setInfiniteStatus(false);
    }
  }

  function seenProductKeys() {
    const keys = new Set();
    grid?.querySelectorAll('.adawat-product-card').forEach((card) => {
      const id = card.querySelector('[data-product-id]')?.getAttribute('data-product-id');
      const href = card.querySelector('a[href*="/products/"]')?.getAttribute('href');
      if (id) keys.add(`id:${id}`);
      if (href) keys.add(`href:${href.split('?')[0]}`);
    });
    return keys;
  }

  async function loadMoreProducts() {
    if (!infiniteEnabled || infiniteLoading || !grid || !infiniteEl) return;
    const nextUrl = infiniteEl.dataset.nextUrl;
    if (!nextUrl) {
      setInfiniteEnabled(false, '');
      return;
    }

    infiniteLoading = true;
    setInfiniteStatus(true);
    try {
      const res = await fetch(nextUrl, {
        headers: { Accept: 'text/html' },
        credentials: 'same-origin',
      });
      if (!res.ok) throw new Error(`Load failed (${res.status})`);
      const html = await res.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const nextGrid = doc.querySelector('[data-collection-grid]');
      const nextSentinel = doc.querySelector('[data-collection-infinite]');
      const existing = seenProductKeys();
      const fragment = document.createDocumentFragment();
      let added = 0;

      nextGrid?.querySelectorAll('.adawat-collection__grid-item:not(.adawat-collection__grid-item--promo)').forEach((item) => {
        const card = item.querySelector('.adawat-product-card');
        const id = card?.querySelector('[data-product-id]')?.getAttribute('data-product-id');
        const href = card?.querySelector('a[href*="/products/"]')?.getAttribute('href');
        const keyId = id ? `id:${id}` : '';
        const keyHref = href ? `href:${href.split('?')[0]}` : '';
        if ((keyId && existing.has(keyId)) || (keyHref && existing.has(keyHref))) return;
        if (currentHandle === '10-picks' && cardPriceDollars(item) > 10.0001) return;
        if (keyId) existing.add(keyId);
        if (keyHref) existing.add(keyHref);
        fragment.appendChild(document.importNode(item, true));
        added += 1;
      });

      if (added) {
        grid.appendChild(fragment);
        window.adawatBindCardGalleries?.();
        window.AdawatWishlist?.sync?.();
        window.AdawatCompare?.sync?.();
        window.AdawatRefreshSale?.();
        if (infiniteLive) infiniteLive.textContent = `${added} more products loaded`;
      }

      const followingUrl = nextSentinel?.getAttribute('data-next-url') || '';
      if (followingUrl) setInfiniteEnabled(true, followingUrl);
      else setInfiniteEnabled(false, '');
    } catch (error) {
      console.warn('[adawat-collection] Infinite scroll failed:', error);
      setInfiniteEnabled(false, '');
    } finally {
      infiniteLoading = false;
      setInfiniteStatus(false);
    }
  }

  function isOffersCollection() {
    if (root.dataset.collectionOffers === 'true') return true;
    const handle = root.dataset.collectionHandle || '';
    return handle === 'exclusive-deals' || handle === 'sale' || handle === 'clearance' || handle === 'on-sale';
  }

  function saleCardCount() {
    return grid?.querySelectorAll('.adawat-product-card').length || 0;
  }

  async function fillOffersFirstScreen() {
    if (!isOffersCollection()) return;
    if (saleCardCount() >= offersFirstCount || !infiniteEnabled) {
      if (infiniteEnabled) observeInfinite();
      return;
    }
    pauseObserve = true;
    infiniteObserver?.disconnect();
    let pages = 0;
    while (saleCardCount() < offersFirstCount && infiniteEnabled && pages < 40) {
      pages += 1;
      const before = saleCardCount();
      const beforeUrl = infiniteEl?.dataset.nextUrl || '';
      await loadMoreProducts();
      const afterUrl = infiniteEl?.dataset.nextUrl || '';
      if (saleCardCount() === before && afterUrl === beforeUrl) break;
      if (!afterUrl) break;
    }
    pauseObserve = false;
    if (infiniteEnabled) observeInfinite();
  }

  function observeInfinite() {
    if (pauseObserve || !infiniteEl || !infiniteEnabled) return;
    if (!('IntersectionObserver' in window)) {
      const onScroll = () => {
        if (!infiniteEnabled || infiniteLoading) return;
        const rect = infiniteEl.getBoundingClientRect();
        if (rect.top < window.innerHeight + 400) loadMoreProducts();
      };
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();
      return;
    }
    infiniteObserver?.disconnect();
    infiniteObserver = new IntersectionObserver(
      (entries) => {
        if (entries.some((entry) => entry.isIntersecting)) loadMoreProducts();
      },
      { rootMargin: '400px 0px' }
    );
    infiniteObserver.observe(infiniteEl);
  }

  function showEmptyState() {
    if (!mainEl) return;
    let empty = mainEl.querySelector('[data-cat-empty]');
    if (!empty) {
      empty = document.createElement('div');
      empty.className = 'adawat-collection__empty';
      empty.dataset.catEmpty = '1';
      empty.innerHTML = `
        <p class="adawat-collection__empty-title">No products found</p>
        <p>Try adjusting your filters or browse another category.</p>
      `;
      mainEl.appendChild(empty);
    }
    empty.hidden = false;
    if (grid) grid.hidden = true;
  }

  function hideEmptyState() {
    const empty = mainEl?.querySelector('[data-cat-empty]');
    if (empty) empty.hidden = true;
    if (grid) grid.hidden = false;
  }

  function heartIconHtml() {
    return `
      <span class="adawat-wishlist-btn__outline">
        <span class="adawat-icon" aria-hidden="true">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"><path d="M20.8 4.6a5.5 5.5 0 00-7.8 0L12 5.7l-1-1.1a5.5 5.5 0 00-7.8 7.8l1 1.1L12 21l7.8-7.5 1-1.1a5.5 5.5 0 000-7.8z"/></svg>
        </span>
      </span>
      <span class="adawat-wishlist-btn__filled">
        <span class="adawat-icon" aria-hidden="true">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M20.8 4.6a5.5 5.5 0 00-7.8 0L12 5.7l-1-1.1a5.5 5.5 0 00-7.8 7.8l1 1.1L12 21l7.8-7.5 1-1.1a5.5 5.5 0 000-7.8z"/></svg>
        </span>
      </span>
    `;
  }

  function compareIconHtml() {
    return `
      <span class="adawat-icon" aria-hidden="true">
        <span class="adawat-compare-glyph"></span>
      </span>
    `;
  }

  function bagIconHtml() {
    return `
      <span class="adawat-product-card__add-btn-icon" aria-hidden="true">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
          <path d="M6.5 8.5h11l-1 11.5H7.5l-1-11.5z"/>
          <path d="M9 8.5V7a3 3 0 0 1 6 0v1.5"/>
        </svg>
      </span>
    `;
  }

  function isSellingFast(product, collectionHandles) {
    const tags = (product.tags || []).map((tag) => String(tag).toLowerCase().trim());
    if (
      tags.includes('selling fast') ||
      tags.includes('selling-fast') ||
      tags.includes('selling_fast') ||
      tags.includes('يباع بسرعة')
    ) {
      return true;
    }
    if (sellingFastUseHandles) {
      return sellingFastHandles.includes(String(product.handle || '').trim());
    }
    if (!sellingFastHandle) return false;
    if (currentHandle === sellingFastHandle) return true;
    return (collectionHandles || []).includes(sellingFastHandle);
  }

  function sellingFastBarHtml() {
    const item = `<span class="adawat-selling-fast__item">${escapeHtml(sellingFastLabel)} <span class="adawat-selling-fast__bolt"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="14" height="14" aria-hidden="true" focusable="false"><path fill="currentColor" d="M13.2 2.1 4.4 14.2c-.35.48 0 1.15.6 1.15h6.05l-1.35 6.32c-.12.55.55.93.94.54l9.05-12.1c.36-.48 0-1.16-.6-1.16h-6.2l1.5-6.32c.13-.55-.54-.95-.93-.53Z"/></svg></span></span>`;
    const group = `<span class="adawat-selling-fast__group">${item}${item}${item}</span>`;
    return `<div class="adawat-selling-fast" aria-hidden="true"><div class="adawat-selling-fast__inner"><div class="adawat-selling-fast__track">${group}${group}</div></div></div>`;
  }

  function renderQuickAdd(product, variant, href) {
    if (product.available === false) {
      return `
        <div class="adawat-product-card__hover-cta">
          <span class="adawat-product-card__add-btn adawat-product-card__add-btn--disabled" aria-disabled="true">
            ${bagIconHtml()}
            <span class="adawat-product-card__add-btn-label">Sold out</span>
          </span>
        </div>
      `;
    }

    const variants = product.variants || [];
    const singleVariant = variants.length <= 1;
    if (!singleVariant || !variant?.id) {
      return `
        <div class="adawat-product-card__hover-cta">
          <a href="${href}" class="adawat-product-card__add-btn" aria-label="Choose options">
            ${bagIconHtml()}
            <span class="adawat-product-card__add-btn-label">Choose Options</span>
          </a>
        </div>
      `;
    }

    return `
      <div class="adawat-product-card__hover-cta">
        <button
          type="button"
          class="adawat-product-card__add-btn"
          data-collection-quick-add="${variant.id}"
          aria-label="Add to cart"
        >
          ${bagIconHtml()}
          <span class="adawat-product-card__add-btn-label">Add to cart</span>
        </button>
      </div>
    `;
  }

  function renderProductCard(product, collectionHandles) {
    const variant = product.variants?.[0] || {};
    const images = product.images || [];
    const img = images[0]?.src || product.featured_image || '';
    const img2 = images[1]?.src || '';
    const sale = saleFromProduct(product, collectionHandles);
    const price = formatMoney(sale.onSale ? sale.price : variant.price);
    const compare = sale.compare;
    const onSale = sale.onSale;
    const discountPercent = sale.percent;
    const href = productUrl(product.handle);
    const title = escapeHtml(product.title);
    const handles = escapeHtml((collectionHandles || []).join('|'));
    const hasSecond = Boolean(img2);
    const sellingFast = isSellingFast(product, collectionHandles);
    const vendor = escapeHtml(product.vendor || '');
    const typeLabel = escapeHtml(product.product_type || '');
    const variantId = variant.id || '';
    const available = product.available === false ? 'Sold out' : 'In stock';
    const listDollars = priceToDollars(variant.price);
    const listCents = priceToCents(variant.price);

    return `
      <li class="adawat-collection__grid-item" data-product-collections="${handles}|">
        <article class="adawat-product-card${hasSecond ? ' adawat-product-card--has-hover-image' : ''}${sellingFast ? ' adawat-product-card--selling-fast' : ''}" data-product-id="${escapeHtml(String(product.id || ''))}" data-variant-id="${escapeHtml(String(variantId || ''))}" data-price-cents="${escapeHtml(String(listCents))}" data-price-dollars="${escapeHtml(listDollars.toFixed(2))}" data-adawat-collections="${escapeHtml((collectionHandles || []).join(','))}" data-adawat-tags="${escapeHtml((product.tags || []).join(','))}"${onSale && discountPercent > 0 ? ` data-adawat-sale-percent="${discountPercent}"` : ''}${sale.basis === 'compare' ? ' data-adawat-sale-basis="compare"' : ''}>
          <div class="adawat-product-card__media-wrap">
            <div class="adawat-product-card__corner">
              <button
                type="button"
                class="adawat-product-card__wishlist adawat-wishlist-btn"
                data-wishlist-toggle
                data-product-id="${product.id}"
                data-product-handle="${escapeHtml(product.handle || '')}"
                data-product-title="${title}"
                data-product-price="${escapeHtml(price)}"
                data-product-image="${escapeHtml(img)}"
                data-product-url="${href}"
                data-variant-id="${escapeHtml(String(variantId))}"
                aria-pressed="false"
                aria-label="Add to wishlist"
              >${heartIconHtml()}</button>
              <button
                type="button"
                class="adawat-product-card__compare"
                data-compare-toggle
                data-product-id="${product.id}"
                data-product-handle="${escapeHtml(product.handle || '')}"
                data-product-title="${title}"
                data-product-price="${escapeHtml(price)}"
                data-product-image="${escapeHtml(img)}"
                data-product-url="${href}"
                data-product-vendor="${vendor}"
                data-product-type="${typeLabel}"
                data-product-available="${available}"
                data-variant-id="${escapeHtml(String(variantId || ''))}"
                aria-pressed="false"
                aria-label="Compare ${title}"
              >${compareIconHtml()}</button>
            </div>
            <a href="${href}" class="adawat-product-card__media-link" aria-label="${title}">
              <div class="adawat-product-card__media" style="aspect-ratio: 1 / 1;">
                ${
                  img
                    ? `<div class="adawat-product-card__slides"${hasSecond ? ' data-card-slides' : ''}>
                    <img class="adawat-product-card__image adawat-product-card__image--primary" src="${escapeHtml(img)}" alt="${title}" loading="lazy" width="600" height="600">
                    ${
                      hasSecond
                        ? `<img class="adawat-product-card__image adawat-product-card__image--secondary" src="${escapeHtml(img2)}" alt="${title}" loading="lazy" width="600" height="600">`
                        : ''
                    }
                  </div>`
                    : `<div class="adawat-product-card__placeholder" style="aspect-ratio: 1 / 1;"></div>`
                }
                <div class="adawat-product-card__badges">
                  ${
                    product.available === false
                      ? `<span class="adawat-badge adawat-badge--soldout">Sold out</span>`
                      : onSale
                        ? discountPercent > 0
                          ? `<span class="adawat-badge adawat-badge--sale">-${discountPercent}%</span>`
                          : ''
                        : ''
                  }
                </div>
              </div>
            </a>
            ${sellingFast ? sellingFastBarHtml() : ''}
            ${
              hasSecond
                ? `<div class="adawat-product-card__dots" data-card-dots>
                    <button type="button" class="adawat-product-card__dot is-active" data-card-dot="0" aria-label="Image 1"></button>
                    <button type="button" class="adawat-product-card__dot" data-card-dot="1" aria-label="Image 2"></button>
                  </div>`
                : ''
            }
            ${renderQuickAdd(product, variant, href)}
          </div>
          <div class="adawat-product-card__info">
            <h3 class="adawat-product-card__title"><a href="${href}">${title}</a></h3>
            <div class="adawat-product-card__footer">
              <div class="adawat-price${onSale ? ' adawat-price--on-sale' : ''}">
                ${
                  onSale
                    ? `<s class="adawat-price__compare">${formatMoney(compare)}</s>`
                    : ''
                }
                <span class="adawat-price__current">${price}</span>
                ${
                  onSale && discountPercent > 0
                    ? `<span class="adawat-price__badge">-${discountPercent}%</span>`
                    : ''
                }
              </div>
              ${renderCardSwatches(product)}
            </div>
          </div>
        </article>
      </li>
    `;
  }

  async function quickAddToCart(variantId, button) {
    if (!variantId || button?.dataset.loading === '1') return;
    if (button) {
      button.dataset.loading = '1';
      button.setAttribute('aria-busy', 'true');
    }
    try {
      if (window.AdawatCart?.add) {
        await window.AdawatCart.add({ id: Number(variantId), quantity: 1 });
      } else {
        const cartRoot = window.Shopify?.routes?.root || '/';
        const res = await fetch(`${cartRoot}cart/add.js`.replace(/\/{2,}/g, '/'), {
          method: 'POST',
          cache: 'no-store',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: Number(variantId), quantity: 1 }),
        });
        if (!res.ok) throw new Error('Add failed');
        document.dispatchEvent(new CustomEvent('cart:update'));
        document.dispatchEvent(new CustomEvent('cart:refresh'));
      }
    } catch (error) {
      console.error(error);
    } finally {
      if (button) {
        button.dataset.loading = '0';
        button.removeAttribute('aria-busy');
      }
    }
  }

  function collectionSectionId() {
    const id = root.closest('[id^="shopify-section-"]')?.id || '';
    return id.replace(/^shopify-section-/, '');
  }

  /**
   * products.json omits sold-out products and has no product.available flag.
   * Shopify's availability filter is the list the sidebar count is counting.
   */
  async function fetchOutOfStockCards(handle) {
    const sectionId = collectionSectionId();
    if (!sectionId || !handle) return [];
    const cards = [];
    const seen = new Set();
    let next = `${collectionsBase()}${handle}?filter.v.availability=0&section_id=${encodeURIComponent(sectionId)}`;
    for (let page = 0; page < 8 && next; page += 1) {
      const res = await fetch(next);
      if (!res.ok) break;
      const html = await res.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      doc.querySelectorAll('.adawat-collection__grid-item').forEach((item) => {
        const key =
          item.querySelector('[data-product-id]')?.getAttribute('data-product-id') ||
          item.querySelector('a[href*="/products/"]')?.getAttribute('href') ||
          '';
        if (!key || seen.has(key)) return;
        seen.add(key);
        cards.push(item);
      });
      const rawNext = doc.querySelector('[data-collection-infinite]')?.getAttribute('data-next-url') || '';
      if (!rawNext) break;
      const nextUrl = new URL(rawNext, window.location.origin);
      nextUrl.searchParams.set('section_id', sectionId);
      const nextString = nextUrl.toString();
      if (nextString === next) break;
      next = nextString;
    }
    return cards;
  }

  function showFilteredCards(nodes) {
    if (!nodes.length) {
      grid.innerHTML = '';
      showEmptyState();
      setInfiniteEnabled(false, '');
      updateResultsCount(0);
      root.querySelectorAll('.adawat-collection__count').forEach((el) => {
        el.textContent = '0 results found';
      });
      return;
    }
    hideEmptyState();
    grid.hidden = false;
    grid.innerHTML = nodes.map((node) => node.outerHTML).join('');
    setInfiniteEnabled(false, '');
    updateResultsCount(nodes.length);
    window.adawatBindCardGalleries?.();
    window.AdawatWishlist?.sync?.();
    window.AdawatRefreshSale?.();
    root.querySelectorAll('.adawat-collection__count').forEach((el) => {
      const label = nodes.length === 1 ? 'result' : 'results';
      el.textContent = `${nodes.length} ${label} found`;
    });
  }

  async function fetchCollectionProducts(handle) {
    const base = collectionsBase();
    const products = [];
    for (let page = 1; page <= 4; page += 1) {
      const res = await fetch(`${base}${handle}/products.json?limit=250&page=${page}`);
      if (!res.ok) break;
      const data = await res.json();
      const batch = data.products || [];
      products.push(...batch);
      if (batch.length < 250) break;
    }
    if (handle === '10-picks') return products.filter(isTenPicksOk);
    return products;
  }

  async function applyFilters() {
    const token = ++loadToken;
    const state = currentFilterState();
    syncFilterUrl(state);
    syncAllCategoryUIs();
    if (!grid) return;

    if (filtersAreDefault(state)) {
      restoreOriginalGrid();
      return;
    }

    const handles = state.cats.length ? state.cats : [currentHandle];
    grid.classList.add('is-loading');
    try {
      if (state.availability === 'out') {
        const lists = await Promise.all(handles.map((handle) => fetchOutOfStockCards(handle)));
        if (token !== loadToken) return;
        const seen = new Set();
        const cards = [];
        lists.flat().forEach((item) => {
          const key = item.querySelector('[data-product-id]')?.getAttribute('data-product-id') || '';
          if (key && seen.has(key)) return;
          if (!cardMatchesFilters(item, state)) return;
          if (key) seen.add(key);
          cards.push(item);
        });
        showFilteredCards(cards);
        return;
      }

      const lists = await Promise.all(handles.map((handle) => getProducts(handle)));
      if (token !== loadToken) return;

      const merged = new Map();
      lists.forEach((list, index) => {
        const handle = handles[index];
        list.forEach((product) => {
          if (!productMatchesFilters(product, state)) return;
          const existing = merged.get(product.id);
          if (existing) existing.handles.add(handle);
          else merged.set(product.id, { product, handles: new Set([handle]) });
        });
      });

      const items = [...merged.values()];
      if (!items.length) {
        grid.innerHTML = '';
        showEmptyState();
        setInfiniteEnabled(false, '');
        updateResultsCount(0);
        return;
      }

      hideEmptyState();
      grid.hidden = false;
      grid.innerHTML = `${items
        .map(({ product, handles }) => renderProductCard(product, [...handles]))
        .join('')}`;
      setInfiniteEnabled(false, '');
      updateResultsCount(items.length);
    window.adawatBindCardGalleries?.();
    window.AdawatWishlist?.sync?.();
    window.AdawatRefreshSale?.();
    root.querySelectorAll('.adawat-collection__count').forEach((el) => {
        const label = items.length === 1 ? 'result' : 'results';
        el.textContent = `${items.length} ${label} found`;
      });
    } catch (error) {
      console.error('Filter failed', error);
    } finally {
      if (token === loadToken) grid.classList.remove('is-loading');
    }
  }

  async function loadProductsForCats(cats) {
    await applyFilters();
  }

  function scheduleCategoryApply(scope) {
    clearTimeout(categoryTimer);
    categoryTimer = setTimeout(() => {
      const cats = selectedCats(scope);
      // Keep sidebar + drawer checkboxes aligned
      const values = new Set(cats);
      root.querySelectorAll('[data-cat-checkbox]').forEach((input) => {
        input.checked = values.has(input.value);
        input.closest('.adawat-collection__cat-check')?.classList.toggle('is-active', input.checked);
      });
      const clonedBody = getDrawerBody();
      if (clonedBody?.dataset.cloned) {
        clonedBody.querySelectorAll('[data-cat-checkbox]').forEach((input) => {
          input.checked = values.has(input.value);
          input.closest('.adawat-collection__cat-check')?.classList.toggle('is-active', input.checked);
        });
      }
      loadProductsForCats(cats);
    }, 280);
  }

  function bindCategoryFilter(scope) {
    scope.querySelectorAll('[data-cat-checkbox]').forEach((input) => {
      if (input.dataset.bound === '1') return;
      input.dataset.bound = '1';
      input.addEventListener('change', () => {
        input.closest('.adawat-collection__cat-check')?.classList.toggle('is-active', input.checked);
        applyFilters();
      });
    });

    syncCategoryCheckboxes(scope);
  }

  function bindFacets(scope) {
    const form = scope.querySelector('[data-adawat-facets]');
    if (!form || form.dataset.bound === '1') return;
    form.dataset.bound = '1';

    scope.querySelectorAll('[data-price-filter]').forEach(bindPriceFilter);
    bindCategoryFilter(scope);

    form.addEventListener('submit', (event) => {
      event.preventDefault();
      applyFilters();
    });
  }

  bindDrawerChrome(getDrawer());
  if (getDrawerBody()?.dataset.cloned) fillDrawer();

  if (!window.__adawatCollectionFiltersUiBound) {
    window.__adawatCollectionFiltersUiBound = true;
    document.addEventListener(
      'click',
      (event) => {
        const openBtn = event.target.closest('[data-collection-filters-open]');
        if (openBtn) {
          event.preventDefault();
          openDrawer();
          return;
        }
        const closeBtn = event.target.closest('[data-collection-filters-close]');
        if (closeBtn) {
          event.preventDefault();
          closeDrawer();
        }
      },
      true
    );
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') closeDrawer();
    });
  }

  sortSelect?.addEventListener('change', () => updateSort(sortSelect.value));
  bindFacets(root);
  loadAdminSwatchMap();
  harvestAdminSwatches();
  hydrateColorFilters();

  async function hydrateColorFilters() {
    const lists = root.querySelectorAll('[data-color-filter-list]');
    if (!lists.length || !currentHandle) return;
    try {
      const products = await getProducts(currentHandle);
      const counts = new Map();
      products.forEach((product) => {
        extractProductColors(product).forEach((label) => {
          counts.set(label, (counts.get(label) || 0) + 1);
        });
      });
      if (!counts.size) {
        root.querySelectorAll('[data-color-filter]').forEach((facet) => {
          if (!facet.querySelector('[data-color-label]')) facet.hidden = true;
        });
        return;
      }

      const params = new URL(window.location.href).searchParams;
      const activeColors = new Set(parseColorParam(params.get('color')).map((v) => v.toLowerCase()));
      lists.forEach((list) => {
        const labels = [...counts.keys()].sort((a, b) => a.localeCompare(b));
        list.innerHTML = labels
          .map((label) => {
            const on = activeColors.has(label.toLowerCase());
            const activeClass = on ? ' is-active' : '';
            const swatch = resolveSwatchColor(label);
            const chipStyle = String(swatch).startsWith('url(')
              ? `background-image: ${swatch}; background-size: cover; background-position: center;`
              : `background-color: ${swatch};`;
            return `<li>
              <button type="button" class="adawat-collection__color-option${activeClass}" data-color-label="${escapeHtml(label)}" aria-pressed="${on ? 'true' : 'false'}">
                <span class="adawat-collection__color-swatch" style="${chipStyle}"></span>
                <span class="adawat-collection__facet-label">${escapeHtml(label)}</span>
                <span class="adawat-collection__facet-count">${counts.get(label)}</span>
              </button>
            </li>`;
          })
          .join('');
      });
      if (activeColors.size) applyFilters();
      const clonedBody = getDrawerBody();
      if (clonedBody) {
        delete clonedBody.dataset.cloned;
        delete clonedBody.dataset.facetsBound;
      }
    } catch (error) {
      console.error('Color filter failed', error);
    }
  }

  function canonicalColorName(raw) {
    const text = String(raw || '')
      .toLowerCase()
      .replace(/[_/]+/g, '-')
      .trim();
    if (!text || text === 'default title') return '';

    const aliases = {
      yello: 'yellow',
      gray: 'grey',
      'off-white': 'white',
      'off white': 'white',
      ivory: 'white',
      noir: 'black',
      blanc: 'white',
    };

    const names = [
      'olive green',
      'nude pink',
      'dusty rose',
      'navy blue',
      'light beige',
      'off white',
      'off-white',
      'navy-blue',
      'chocolate',
      'burgundy',
      'mustard',
      'silver',
      'yellow',
      'yello',
      'orange',
      'purple',
      'violet',
      'green',
      'olive',
      'beige',
      'cream',
      'brown',
      'black',
      'white',
      'ivory',
      'navy',
      'blue',
      'grey',
      'gray',
      'pink',
      'rose',
      'red',
      'gold',
      'tan',
    ];

    const compact = text.replace(/[^a-z]+/g, '');
    let found = '';
    for (const name of names) {
      const token = name.replace(/[^a-z]+/g, '');
      if (!token) continue;
      if (text.includes(name) || compact.includes(token) || compact.endsWith(token)) {
        found = name;
        break;
      }
    }
    if (!found) return '';
    const key = aliases[found] || found;
    return key.replace(/\b\w/g, (ch) => ch.toUpperCase());
  }

  function extractProductColors(product) {
    const found = new Set();
    const options = product.options || [];
    options.forEach((opt) => {
      const name = String(opt.name || opt || '').toLowerCase();
      const isColor =
        name === 'color' ||
        name === 'colour' ||
        name === 'لون' ||
        name.includes('color') ||
        name.includes('colour');
      if (!isColor) return;
      const values = Array.isArray(opt.values) ? opt.values : [];
      values.forEach((value) => {
        const label = canonicalColorName(value);
        if (label) found.add(label);
      });
    });
    (product.variants || []).forEach((variant) => {
      ['option1', 'option2', 'option3'].forEach((key, index) => {
        const opt = options[index];
        const optName = String(opt?.name || opt || '').toLowerCase();
        if (!optName.includes('color') && !optName.includes('colour') && optName !== 'لون') return;
        const label = canonicalColorName(variant[key]);
        if (label) found.add(label);
      });
    });
    return found;
  }

  function toggleColorSelection(label) {
    const wanted = String(label || '').toLowerCase();
    if (!wanted) return;
    const next = new Set(selectedColors(root).map((v) => v.toLowerCase()));
    if (next.has(wanted)) next.delete(wanted);
    else next.add(wanted);

    const labels = [];
    root.querySelectorAll('[data-color-label]').forEach((el) => {
      const value = el.getAttribute('data-color-label');
      if (!value) return;
      if (next.has(value.toLowerCase()) && !labels.some((v) => v.toLowerCase() === value.toLowerCase())) {
        labels.push(value);
      }
    });
    // Fallback if sidebar not hydrated yet — keep clicked label casing
    if (!labels.length && next.has(wanted)) labels.push(label);
    syncColorActiveState(labels);
  }

  const viewButtons = root.querySelectorAll('[data-view-mode]');
  function setViewMode(mode) {
    const next = mode === 'list' ? 'list' : 'grid';
    root.classList.toggle('is-list-view', next === 'list');
    viewButtons.forEach((btn) => {
      const active = btn.getAttribute('data-view-mode') === next;
      btn.classList.toggle('is-active', active);
      btn.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
    try {
      sessionStorage.setItem('adawat-collection-view', next);
    } catch (e) {
      /* ignore */
    }
  }
  viewButtons.forEach((btn) => {
    btn.addEventListener('click', () => setViewMode(btn.getAttribute('data-view-mode')));
  });
  try {
    const savedView = sessionStorage.getItem('adawat-collection-view');
    if (savedView) setViewMode(savedView);
  } catch (e) {
    /* ignore */
  }

  document.addEventListener('click', (event) => {
    const colorLink = event.target.closest('[data-color-label]');
    if (colorLink && (root.contains(colorLink) || getDrawer()?.contains(colorLink))) {
      event.preventDefault();
      toggleColorSelection(colorLink.getAttribute('data-color-label'));
      applyFilters();
      return;
    }

    const availLink = event.target.closest('[data-availability]');
    if (availLink && (root.contains(availLink) || getDrawer()?.contains(availLink))) {
      event.preventDefault();
      const key = availLink.getAttribute('data-availability');
      const turningOn = !availLink.classList.contains('is-active');
      setActiveGroup(`[data-availability="${key}"]`, turningOn);
      applyFilters();
      return;
    }
  });

  root.addEventListener('click', (event) => {
    const btn = event.target.closest('[data-collection-quick-add]');
    if (!btn || !root.contains(btn)) return;
    event.preventDefault();
    event.stopPropagation();
    quickAddToCart(btn.getAttribute('data-collection-quick-add'), btn);
  });

  const bootParams = new URL(window.location.href).searchParams;
  const bootAvail = bootParams.get('availability');
  if (bootAvail) {
    root.querySelector(`[data-availability="${bootAvail}"]`)?.classList.add('is-active');
  }

  stripOverTenPicks();
  if (grid) initialGridHTML = grid.innerHTML;

  // On load: if ?cats= is present, load those category products immediately
  const initialCats = (bootParams.get('cats') || '')
    .split(',')
    .map((v) => v.trim())
    .filter(Boolean);
  if (initialCats.length || bootAvail) {
    syncAllCategoryUIs();
    applyFilters();
  } else if (isOffersCollection()) {
    fillOffersFirstScreen();
  } else {
    observeInfinite();
  }

  const path = window.location.pathname;
  root.querySelectorAll('.adawat-collection__sub').forEach((link) => {
    try {
      const hrefPath = new URL(link.href, window.location.origin).pathname.replace(/\/$/, '');
      const current = path.replace(/\/$/, '');
      if (hrefPath && hrefPath === current) {
        root.querySelectorAll('.adawat-collection__sub').forEach((el) => el.classList.remove('is-active'));
        link.classList.add('is-active');
      }
    } catch (error) {
      /* ignore */
    }
  });

  /* Keep shop/collection scroll when opening a product and when using browser Back */
  const collectionScrollKey = `adawat-col-scroll:${location.pathname}${location.search}`;

  function collectionScrollY() {
    try {
      const wrapper = document.querySelector('.page-wrapper');
      if (
        wrapper instanceof HTMLElement &&
        typeof window.matchMedia === 'function' &&
        window.matchMedia('(min-width: 990px)').matches
      ) {
        return wrapper.scrollTop || 0;
      }
    } catch (_) {
      /* ignore */
    }
    return window.scrollY || window.pageYOffset || document.documentElement.scrollTop || 0;
  }

  function setCollectionScrollY(y) {
    const top = Math.max(0, Number(y) || 0);
    try {
      const wrapper = document.querySelector('.page-wrapper');
      if (
        wrapper instanceof HTMLElement &&
        typeof window.matchMedia === 'function' &&
        window.matchMedia('(min-width: 990px)').matches
      ) {
        wrapper.scrollTo({ top, behavior: 'instant' });
        return;
      }
    } catch (_) {
      /* ignore */
    }
    window.scrollTo({ top, behavior: 'instant' });
  }

  function saveCollectionScroll() {
    try {
      const y = collectionScrollY();
      if (y > 0) sessionStorage.setItem(collectionScrollKey, String(y));
    } catch (_) {
      /* ignore */
    }
  }

  function restoreCollectionScroll() {
    let y = 0;
    try {
      y = Number(sessionStorage.getItem(collectionScrollKey) || 0);
    } catch (_) {
      y = 0;
    }
    if (!Number.isFinite(y) || y <= 0) return;
    const apply = () => setCollectionScrollY(y);
    apply();
    requestAnimationFrame(apply);
    setTimeout(apply, 50);
    setTimeout(apply, 200);
    setTimeout(apply, 500);
    setTimeout(apply, 1000);
  }

  root.addEventListener(
    'click',
    (event) => {
      const link = event.target instanceof Element ? event.target.closest('a[href]') : null;
      if (!(link instanceof HTMLAnchorElement) || !root.contains(link)) return;
      try {
        const url = new URL(link.href, location.origin);
        if (url.origin !== location.origin) return;
        if (!/\/products\//.test(url.pathname)) return;
        saveCollectionScroll();
      } catch (_) {
        /* ignore */
      }
    },
    true
  );

  window.addEventListener('pagehide', saveCollectionScroll);
  window.addEventListener('pageshow', restoreCollectionScroll);

  try {
    const nav = performance.getEntriesByType?.('navigation')?.[0];
    if (nav && (nav.type === 'back_forward' || Number(sessionStorage.getItem(collectionScrollKey) || 0) > 0)) {
      restoreCollectionScroll();
    }
  } catch (_) {
    /* ignore */
  }
})();
